app.service("ImageService", ['$rootScope', function ($rootScope) {

    const service = this;

    const ImageModel = function () {
        this.image_info = {};
        this.style_increment = 1;
    };

    this.model = new ImageModel();
    const model = this.model;

    this.imageLoadHandler = function (event) {
        const target = event.target;
        if (!target) {
            return false;
        }

        const imgSrc = target.currentSrc;
        const width = target.width;
        const height = target.height;

        if (!imgSrc || !width | !height || model.image_info[imgSrc]) {
            return false;
        }
        model.image_info[imgSrc] = {
            src: imgSrc,
            width: width,
            height: height
        }
    }

    this.getImageRatioClass = function (imgSrc) {
        if (!imgSrc) {
            return "";
        }
        const http = "http://";
        const https = "https://";
        if (imgSrc.substring(0, http.length) !== http && imgSrc.substring(0, https.length) !== https) {
            imgSrc = window.location.protocol + "//" + window.location.hostname + imgSrc;
        }


        const info = model.image_info[imgSrc];
        if (!info || !info.width || !info.height) {
            return "";
        }
        const ratio = info.width / info.height;
        if (ratio > 3) {
            return 'ratio-widest';
        }
        if (ratio > 2) {
            return 'ratio-wider';
        }
        if (ratio > 1.25) {
            return 'ratio-wide';
        }
        if (ratio > 0.75) {
            return 'ratio-square';
        }
        if (ratio > 0.5) {
            return 'ratio-tall';
        }
        if (ratio > 0.33) {
            return 'ratio-taller';
        }
        return 'ratio-tallest'
    }

    this.determineImgSrc = function (params) {
        const siteRangeID = params.site_range_id ? params.site_range_id : null;
        const colourID = params.colour_id ? params.colour_id : null;
        const styleID = params.style_id ? params.style_id : null;
        const apiCode = params.api_code ? params.api_code : null;
        switch (params.image_type_id) {
            case "style":
                return service.getStyleImgSrc(siteRangeID, colourID, styleID, params);
            case "colour":
                return service.getColourImgSrc(siteRangeID, colourID, params);
            case "sloping_style":
                return getSlopingStyleImgSrc(colourID, styleID, params);
            case "product":
                return getProductImgSrc(siteRangeID, apiCode, params);
            default:
                return null;
        }
    }


    this.getStyleImgSrc = function (siteRangeID, colourID, styleID, params) {

        if (!isLocalImageReady()) {
            return null;
        }
        const imgSrc = colourID ? $rootScope.service.image.getLocalStyleImgSrc(siteRangeID, colourID, styleID) : null;
        if (imgSrc) {
            return imgSrc;
        }


        if (siteRangeID === "bella") {
            return service.getRemoteStyleImgSrc(colourID, styleID, params);
        }

        return service.getRemoteColourImgSrc(siteRangeID, colourID, params);
    }

    const definedLocalStyleImgSrc = (siteRangeID, colourID, styleID) => {
        if(siteRangeID === "bella"){
            if(styleID === "aldridge"){
                return "/img/browse/property/override/override-aldridge.jpg"
            }
        }
        return null;
    }

    this.getLocalStyleImgSrc = function (siteRangeID, colourID, styleID) {

        const definedSrc = definedLocalStyleImgSrc(siteRangeID, colourID, styleID);
        if(definedSrc){
            return definedSrc;
        }

        if (!isLocalImageReady()) {
            return null;
        }
        const requestRangeID = $rootScope.service.site_range.getRequestRangeID(siteRangeID);


        const byRequestRangeID = localImage() && localImage().door && localImage().door.door ? localImage().door.door[requestRangeID] : null;
        if (!byRequestRangeID) {
            return null;
        }
        let imgSrc;
        if (requestRangeID !== "bella") {
            imgSrc = byRequestRangeID[colourID];
        } else {
            imgSrc = styleID && byRequestRangeID[styleID] ? byRequestRangeID[styleID][colourID] : null;
        }

        imgSrc += "?i=" + model.style_increment;

        return imgSrc ? localImageHost() + imgSrc : null;
    }

    this.getRemoteStyleImgSrc = function (colourID, styleID, params) {
        let imgSrc = '/request/api-image.php/ranges/bella/styles/' + styleID;
        if (colourID) {
            imgSrc += '/colours/' + colourID;
        }
        imgSrc += '/image'
        const defaultQueryParams = {
            width: null,
            height: null,
            mode: "fit"
        }
        const queryParams = getValidParams(defaultQueryParams, params);
        return addQueryParams(imgSrc, queryParams);
    }

    function getValidParams(defaultParams, fromParams) {
        const validParams = {};
        for (let key in defaultParams) {
            const value = fromParams && (fromParams[key] !== undefined && fromParams[key] !== null && fromParams[key] !== "") ? fromParams[key] : defaultParams[key];
            if (value !== null) {
                validParams[key] = value;
            }
        }
        return validParams;
    }


    function addQueryParams(src, params) {
        let isAnd = src.includes("?");
        for (let key in params) {
            src += !isAnd ? "?" : "&";
            isAnd = true;
            src += key + "=" + params[key];
        }
        return src;
    }


    this.getColourImgSrc = function (siteRangeID, colourID, params) {

        if (!isLocalImageReady()) {
            return null;
        }
        const imgSrc = $rootScope.service.image.getLocalColourImgSrc(siteRangeID, colourID);
        if (imgSrc) {
            return imgSrc;
        }

        return service.getRemoteColourImgSrc(siteRangeID, colourID, params);
    }

    this.getLocalColourImgSrc = function (siteRangeID, colourID) {
        if (!isLocalImageReady()) {
            return null;
        }
        const requestRangeID = $rootScope.service.site_range.getRequestRangeID(siteRangeID);

        const swatch = localImage() ? localImage().swatch : null;
        return swatch && swatch[requestRangeID] && swatch[requestRangeID][colourID] ? localImageHost() + swatch[requestRangeID][colourID] : null;
    }

    this.getRemoteColourImgSrc = function (siteRangeID, colourID, params) {
        const requestRangeID = $rootScope.service.site_range.getRequestRangeID(siteRangeID);

        const imgSrc = '/request/api-image.php/ranges/' + requestRangeID + '/colours/' + colourID + '/image';
        const defaultQueryParams = {
            width: null,
            height: null,
            mode: "fit"
        }
        const queryParams = getValidParams(defaultQueryParams, params);
        if (requestRangeID === "bella") {
            queryParams.is_png = true;
        }
        return addQueryParams(imgSrc, queryParams);
    }

    function getSlopingStyleImgSrc(colourID, styleID, params) {

        const imgSrc = colourID ? getLocalDoorSloping(colourID, styleID) : null;
        if (imgSrc) {
            return imgSrc;
        }
        return service.getStyleImgSrc("bella", colourID, styleID, params);
    }

    function getPostParams(params) {
        const defaultPostParams = {

            //door/frame
            rotate_grain: null,

            option_id: null,
            midrail: null,
            knebworth_position: null,
            handle_position: null,
            hand: null,

            left_angle_height: null,
            left_angle_width: null,
            right_angle_height: null,
            right_angle_width: null,

            doors: null,
            door_spacing: null,

            left_spacing: null,
            right_spacing: null,
            top_spacing: null,
            bottom_spacing: null,

            left_angle_spacing: null,
            right_angle_spacing: null,

            //panel
            length: null,
            depth: null,
            front_profiled: null,
            back_profiled: null,
            left_profiled: null,
            right_profiled: null,
            angle_length: null,
            angle_depth: null,
            front_left_angle: null,
            front_right_angle: null,
            back_left_angle: null,
            back_right_angle: null,
            front_left_radius: null,
            front_right_radius: null,
            back_left_radius: null,
            back_right_radius: null,
            corner_position: null,
            side_length: null,
            side_depth: null,
            corner_radius: null,
            middle_radius: null,
            side_length_profiled: null,
            side_depth_profiled: null,

            panels: null,
            top_panel_height: null,
            bottom_panel_height: null,

            //solution
            unit: null,

            //stock
            product_code: null
        }

        const postParams = getValidParams(defaultPostParams, params);

        if (params.product_width) {
            postParams.width = params.product_width;
        }
        if (params.product_height) {
            postParams.height = params.product_height;
        }
        if (params.colour_id) {
            postParams.colour = params.colour_id;
        }
        if (params.style_id) {
            postParams.style = params.style_id;
        }

        const hingeHoles = $rootScope.service.product.collectHingeHoles(params, true);
        if (hingeHoles) {
            postParams.hinge_holes = hingeHoles;
        }
        return postParams;
    }

    function getProductImgSrc(siteRangeID, apiCode, params) {
        const requestRangeID = $rootScope.service.site_range.getRequestRangeID(siteRangeID);
        const imgSrc = '/request/api-image.php/ranges/' + requestRangeID + '/products/' + apiCode + '/image.png';
        const defaultQueryParams = {
            width: null,
            height: null
        }
        const queryParams = getValidParams(defaultQueryParams, params);
        queryParams.is_png = true;

        const postParams = getPostParams(params);
        if (params.door_options) {
            const doorOptions = [];
            for (let i = 0; i < params.door_options.length; i++) {
                const door_option = getPostParams(params.door_options[i]);
                doorOptions.push(door_option);
            }
            postParams.door_options = doorOptions;
        }

        queryParams.post_json = encodeURI(JSON.stringify(postParams));
        return addQueryParams(imgSrc, queryParams);
    }


    function localImage() {
        return $rootScope.model.cache_local_server.local_image;
    }

    function isLocalImageReady() {
        return !!$rootScope.service.cache_local_server.cache_initialized;
    }

    function localImageHost() {
        return localImage().host ? localImage().host : "/";
    }

    function getLocalDoorSloping(colourID, styleID) {
        const sloping = localImage() && localImage().door ? localImage().door.sloping : null;
        return sloping && sloping.bella && sloping.bella[styleID] && sloping.bella[styleID][colourID] ? localImageHost() + sloping.bella[styleID][colourID] : null;
    }
}]);